import { Box, Colors, Text } from '@factorialco/deprecated-design-system'
import { CardDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { canViewSecretData } from 'modules/banking/lib/cards/canViewSecretData'
import { isRequested } from 'modules/banking/lib/cards/isRequested'
import { BankingCard } from 'modules/banking/lib/cards/types'

import { CardImage } from '../_CardImage'

const cardBackgroundColor = (card: BankingCard): Colors => {
  switch (card.type) {
    case 'physical':
      return 'grey000White'
    case 'virtual':
      return 'radicalRed1000'
    case 'single_use':
      return 'viridian1000'
  }
}

export const CardDetails: React.FC<{ card: CardDetailFragment }> = ({ card }) => {
  const background = cardBackgroundColor(card)
  const showCardDetails = canViewSecretData(card)

  return (
    <Box width="s360">
      <Box flexDirection="column" gap="s12" width="s360" alignSelf="flexEnd">
        <Box
          alignSelf="flexEnd"
          width="s360"
          borderRadius={{ all: 'abs012' }}
          background={background}
          style={{ opacity: showCardDetails ? '1.0' : '0.4' }}
        >
          <CardImage key={card.id} card={card} canSeeCardDetails={showCardDetails} />
        </Box>
        {isRequested(card) && (
          <Box
            background="grey200"
            padding="s12"
            borderRadius={{ all: 'abs008' }}
            alignItems="center"
            justifyContent="center"
          >
            {!card.description && (
              <Text.Normal>{i18n.t('expenses_v2.cards.details.awaiting_approve')}</Text.Normal>
            )}
            {card.description && (
              <Text.Normal>
                {i18n.t('expenses_v2.cards.details.awaiting_approve_with_request', {
                  reason: card.description,
                })}
              </Text.Normal>
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}
